import { Auth } from 'aws-amplify'
import { useEffect, useState } from 'react'

import useAuth from './useAuth'

export default () => {
    const [uuid, setUUID] = useState<string | undefined>(undefined)
    const auth = useAuth()

    useEffect(() => {
        (async () => {
            try {
                const session = await Auth.currentSession()
                const tokenString = session.getIdToken().getJwtToken()
                const secondPart = tokenString.split('.')?.[1]
                if (!secondPart) return setUUID(undefined)
                const cognitoUUID = JSON.parse(atob(secondPart))?.sub
                return setUUID(cognitoUUID)
            } catch {
                return setUUID(undefined)
            }
        })()
    }, [auth.username])

    return uuid
}